// extracted by mini-css-extract-plugin
module.exports = {"other":"Filling_other__1grM_","tabs":"Filling_tabs__1fPQO"};